module.exports = __webpack_public_path__ + "assets/img/smsimg1.605f93eb.png";